import HttpCliente from "../HttpCliente";

export const getOrganismoEmisor = (token) => {
  return new Promise((resolve, reject) => {
    HttpCliente.get("/OrganismoEmisor/ObtenerOrganismosEmisores", {
      headers: {
        "Authorization": `Bearer ${token}`,
        'accept': 'text/plain'
      }
    }).then(response => {
        resolve(response.data);
        }).catch(error => {
        reject(error);
        });
    });
}

export const postOrganismoEmisor = (token, organismo) => {
  return new Promise((resolve, reject) => {
    HttpCliente.post("/OrganismoEmisor/Crear", organismo, {
      headers: {
        "Authorization": `Bearer ${token}`,
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      }
    }).then(response => {
      resolve(response.data);
    }).catch(error => {
      reject(error);
    });
  });
};

export const putOrganismoEmisor = (token, organismo) => {
  return new Promise((resolve, reject) => {
    HttpCliente.put("/OrganismoEmisor/EditarOrganismoEmisor", organismo, {
      headers: {
        "Authorization": `Bearer ${token}`,
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        }
    }).then(response => {
        resolve(response.data);
        }).catch(error => {
        reject(error);
        });
    });
}

export const deleteOrganismoEmisor = (token, id) => {
  return new Promise((resolve, reject) => {
    HttpCliente.delete(`/OrganismoEmisor/Deshabilitar/${id}`, {
      headers: {
        "Authorization": `Bearer ${token}`,
        'accept': 'text/plain'
      }
    }).then(response => {
        resolve(response.data);
        }).catch(error => {
        reject(error);
        });
    });
}

export const getOrganismoEmisorHabilitado = (token) => {
  return new Promise((resolve, reject) => {
    HttpCliente.get("/OrganismoEmisor/ObtenerOrganismoEmisorHabilitado", {
      headers: {
        "Authorization": `Bearer ${token}`,
        'accept': 'text/plain'
      }
    }).then(response => {
        resolve(response.data);
        }).catch(error => {
        reject(error);
        });
    });
}

export const getOrganismosClientes = (token, id) => {
  return new Promise((resolve, reject) => {
    HttpCliente.get(`/OrganismoEmisor/ObtenerOrganismosClientes/${id}`, {
      headers: {
        "Authorization": `Bearer ${token}`,
        'accept': 'text/plain'
      }
    }).then(response => {
        resolve(response.data);
        }).catch(error => {
        reject(error);
        });
    });
}

export const postRelacionOrganismoTipoDocumento = (token, relacion) => {
  return new Promise((resolve, reject) => {
    HttpCliente.post('/OrganismoEmisor/RelacionarOrganismoTipoDocumento', relacion, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'accept': 'text/plain',
        'Content-Type': 'application/json',
      }
    }).then(response => {
      resolve(response.data);
    }).catch(error => {
      reject(error);
    });
  });
};